import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { AnnouncementState, AnnouncementStore } from './announcement.store';



@Injectable({ providedIn: 'root' })
export class AnnouncementQuery extends Query<AnnouncementState> {


    announcement$ = this.select("announcement")
    selectedAnnouncement$ = this.select('selectedAnnouncement')
   
    constructor(protected override store: AnnouncementStore) {
        super(store);
    }
}

